import { Link } from 'react-router-dom';

export default function LatestSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12" aria-labelledby="latest-title">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-comic-accent text-xs font-medium tracking-widest mb-3">DAILY UPDATES</p>
            <h2 id="latest-title" className="text-3xl md:text-5xl font-black text-white">
              每日<span className="text-comic-primary">更新</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm hidden md:block">实时追踪 · 快人一步</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {/* 卡片1: 大小姐的贴身管家 */}
          <Link to="/comic/new-1" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20elegant%20butler%20and%20noble%20lady%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality%2C%20vertical%20portrait%20format&width=450&height=600&seq=comic-lady-butler-latest&orientation=portrait"
                  alt="大小姐的贴身管家"
                  title="大小姐的贴身管家 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    大小姐的贴身管家
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第342话</p>
                    <p className="text-gray-400 text-xs">2小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片2: 最强赘婿 */}
          <Link to="/comic/new-2" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20powerful%20son%20in%20law%20character%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-strongest-son-in-law-latest&orientation=portrait"
                  alt="最强赘婿"
                  title="最强赘婿 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    最强赘婿
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第521话</p>
                    <p className="text-gray-400 text-xs">3小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片3: 剑道独尊 */}
          <Link to="/comic/new-3" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20sword%20master%20dramatic%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-sword-dominance-latest&orientation=portrait"
                  alt="剑道独尊"
                  title="剑道独尊 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-accent/90 text-white">HOT</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    剑道独尊
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第198话</p>
                    <p className="text-gray-400 text-xs">5小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片4: 恶魔契约 */}
          <Link to="/comic/new-4" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20demon%20contract%20fantasy%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-demon-contract-latest&orientation=portrait"
                  alt="恶魔契约"
                  title="恶魔契约 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    恶魔契约
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第76话</p>
                    <p className="text-gray-400 text-xs">6小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片5: 我的女友是九尾狐 */}
          <Link to="/comic/new-5" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20nine%20tailed%20fox%20romance%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-nine-tail-fox-latest&orientation=portrait"
                  alt="我的女友是九尾狐"
                  title="我的女友是九尾狐 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    我的女友是九尾狐
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第203话</p>
                    <p className="text-gray-400 text-xs">8小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片6: 暗黑破坏神之怒 */}
          <Link to="/comic/new-6" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20dark%20fantasy%20wrath%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-diablo-wrath-latest&orientation=portrait"
                  alt="暗黑破坏神之怒"
                  title="暗黑破坏神之怒 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-accent/90 text-white">HOT</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    暗黑破坏神之怒
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第89话</p>
                    <p className="text-gray-400 text-xs">10小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片7: 全职猎人之重生 */}
          <Link to="/comic/new-7" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20hunter%20rebirth%20action%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-hunter-rebirth-latest&orientation=portrait"
                  alt="全职猎人之重生"
                  title="全职猎人之重生 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    全职猎人之重生
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第167话</p>
                    <p className="text-gray-400 text-xs">12小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片8: 斗罗之绝世唐门 */}
          <Link to="/comic/new-8" className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover h-full">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20soul%20land%20epic%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-douluo-door-latest&orientation=portrait"
                  alt="斗罗之绝世唐门"
                  title="斗罗之绝世唐门 - 韩国漫画网每日更新"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan/90 text-black">FREE</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-4 pt-8">
                  <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                    斗罗之绝世唐门
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-300 text-xs">第412话</p>
                    <p className="text-gray-400 text-xs">14小时前</p>
                  </div>
                </div>
              </div>
            </article>
          </Link>
        </div>

        {/* 底部导航箭头 */}
        <div className="flex justify-center gap-4 mt-8">
          <button className="w-10 h-10 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-white hover:border-comic-primary transition-all duration-200 cursor-pointer" aria-label="上一页">
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button className="w-10 h-10 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-white hover:border-comic-primary transition-all duration-200 cursor-pointer" aria-label="下一页">
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}